const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://arbcor-web-api.vercel.app';

// Token renewer is set by AuthContext so apiClient can trigger silent renewal on 401
let tokenRenewer = null;
let renewalPromise = null;

export function setTokenRenewer(fn) {
  tokenRenewer = fn;
}

export async function apiFetch(path, options = {}) {
  const response = await rawFetch(path, options);

  // If 401 and we have a renewer, try to refresh and retry once
  if (response.status === 401 && tokenRenewer) {
    try {
      // Deduplicate concurrent renewal attempts
      if (!renewalPromise) {
        renewalPromise = tokenRenewer().finally(() => { renewalPromise = null; });
      }
      await renewalPromise;
      // Retry with the new token
      return rawFetch(path, options);
    } catch {
      // Renewal failed — return original 401
      return response;
    }
  }

  return response;
}

async function rawFetch(path, options = {}) {
  const accessToken = localStorage.getItem('access_token');

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const companyId = options.companyId || localStorage.getItem('active_company_id');
  if (companyId) {
    headers['X-Company-ID'] = companyId;
  }

  return fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });
}
